import { GraphQLQuery } from '@settings/services/graphQLClient/GraphQLClient';
import gql from 'graphql-tag';

import { LocalizedMessage } from '../../localizedMessagesService/interfaces';

// Данные фуры
export interface TrucksData {
  id: string;
  default_name: string;
  localized_names: string[];
  localized_names_data: LocalizedMessage[];
  countPallets: {
    type_pallet: string;
    count_pallet: number;
  }[];
  height: number;
  width: number;
  length: number;
  ldm: number;
  max_weight: number;
  max_volume: number;
}

export interface TrucksLoaderQueryResponse {
  items: TrucksData[];
}

/**
 * Запрос загрузки данных по фурам
 */
export class TrucksLoaderQuery implements GraphQLQuery<null> {
  readonly query: any;

  readonly variables: null;

  constructor(ids?: any[]) {
    this.variables = null;
    this.query = gql`
            query LoadTrucks {
                items: transport_truck_list(
				    order: [{ by: priority, direction: asc, priority: 1 }]
                    limit: 1000000
                    ${
                      ids && ids.length > 0
                        ? `where:{id:{_in: [${ids.map((id) => `"${id}"`).join(',')}]}}`
                        : ``
                    }
                ) {
                    id
                    default_name
                    localized_names
					countPallets {
						type_pallet
						count_pallet
					}
					height
					width
					length
					ldm
					max_weight
					max_volume
                }
            }
        `;
  }
}
